





















































































































































import { Component, Vue } from 'vue-property-decorator'
import { BranchOperatingZoneAPI, PipelineAPI } from '@/api/backend-client'
import { BranchOperatingZone } from '@/api/model/branch-operating-zone'
import { Branch } from '@/api/model/branch'
import { Pipeline } from '@/api/model/pipeline'

@Component
export default class OperatingZones extends Vue {
    loading: boolean = false
    multiSelect: boolean = false
    branchOperatingZones: BranchOperatingZone[] = []
    pipelines: Pipeline[] = []
    operatingZoneSelection: string[] = []
    clickedZone: string|null = null
    selectedPipelineId: string|null = null
    selectedBranchId: string|null = null
    showCreateModal: boolean = false
    showCopyModal: boolean = false
    showDeleteConfirmModal: boolean = false

    async mounted(): Promise<void> {
        await this.loadLocalValues()

        if (this.availablePipelines.length > 0) {
            this.selectedPipelineId = this.availablePipelines[0].id
        }

        if (this.availableBranches.length > 0) {
            this.selectedBranchId = this.availableBranches[0].id
        }
    }

    async onCreate(createEvent: { pipeline: Pipeline, branch: Branch}): Promise<void> {
        await this.loadLocalValues()

        this.selectedPipelineId = createEvent.pipeline.id
        this.selectedBranchId = createEvent.branch.id
    }

    async loadLocalValues(): Promise<void> {
        this.loading = true

        this.operatingZoneSelection = []
        this.clickedZone = null

        this.branchOperatingZones = await BranchOperatingZoneAPI.getAll({
            'pipeline.company': this.$currentCompany.resourceIdentifier,
        })

        this.pipelines = await PipelineAPI.getAll({
            company: this.$currentCompany.resourceIdentifier,
            active: 1,
        })

        this.loading = false
    }

    get operatingZoneOptions(): Array<{label: string, value: string}> {
        return this.availableOperatingZones.map(branchOperatingZone => {
            return {
                label: branchOperatingZone.areaCode.toString(),
                value: branchOperatingZone.id,
            }
        })
    }

    get availableOperatingZones(): BranchOperatingZone[] {
        return this.branchOperatingZones
            .filter(operatingZone => {
                return operatingZone.pipeline.id === this.selectedPipelineId &&
                    operatingZone.branch.id === this.selectedBranchId
            })
            .sort((a: BranchOperatingZone, b: BranchOperatingZone) => a.areaCode.toString().localeCompare(b.areaCode.toString()))
    }

    get availablePipelines(): Pipeline[] {
        return this.pipelines
            .sort((a: Pipeline, b: Pipeline) => a.name.localeCompare(b.name))
    }

    get availableBranches(): Branch[] {
        return this.$currentCompany.getAvailableBranches()
            .filter(branch => {
                return this.branchOperatingZones.find(branchOperatingZone => {
                    return branchOperatingZone.branch.id === branch.id &&
                        branchOperatingZone.pipeline.id === this.selectedPipelineId
                })
            })
            .sort((a: Branch, b: Branch) => a.name.localeCompare(b.name))
    }
}
